export default {
  lucky: {
    prizeAgain: 'I-spin Muli',
    prizeThanks: 'Suwerte Sa Susunod',
    remainingChance: 'Natitirang Pagkakataon',
    task: 'Gawain',
    deposit: 'Deposito',
    wager: 'Taya',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Koleksyon ng Card',
    puzzleRound: 'Round {current}/{total}',
    puzzleReward: 'Reward sa pagkumpleto {amount}',
    redeem: 'I-redeem',
    redeemSuccess: 'Matagumpay na na-redeem',
    redeemSuccessWithReward: 'Matagumpay na na-redeem! Nakuha mo ang {amount} {currency}',
    redeemFailed: 'Nabigo ang pag-redeem',
    notComplete: 'Hindi pa kumpleto, hindi maaaring i-redeem',
    drawFailed: 'Nabigo ang draw, subukan muli',
    gainLetter: 'Binabati kita! Nakuha mo ang letrang {letter}',
    gainBlock: 'Binabati kita! Nakuha mo ang larawang {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Imbitahan',
    claimReward: 'Kunin',
    noChest: 'Walang kaban',
    claimSuccess: 'Kinuha ang {count} kaban, {amount} {currency}',
    modalTitle: 'Kaban ng kayamanan',
    modalSubtitle: 'I-swipe upang makita lahat',
    chipTodayClaimed: 'Nakuha ngayon',
    chipClaimable: 'Maaaring kunin',
    chipLocked: 'Naka-lock',
    totalClaimedCount: 'Kabuuang kaban na nakuha',
    totalClaimedAmount: 'Kabuuang halaga na nakuha',
    chestUnit: 'pcs',
    claimAll: 'Kunin lahat',
    goInvite: 'Mag-imbita',
    claimSingleSuccess: 'Nakuha ang {amount} {currency}',
    labelClaimed: 'Nakuha',
    labelClaimable: 'Maaaring kunin',
    labelLocked: 'Naka-lock',
  },
}
